/* Farm Day Trips plus (theme update 2026-10-18g). Visual touches on top of the directory, listing pages and visitor guides,
   without changing what's on them (nothing is removed; every button and link keeps working):
   - a card with no picture gets a painted cover for its kind of place (orchard, lavender, café, inn…); a farm with only its
     3D picture or logo shows that and the painted cover in turns, like a photo carousel (listing pages too)
   - "★ Sponsor" and "★ New listing" use the painted star like every other badge
   - a listing with no reviews yet says "Be the first to review" instead of five empty stars
   - a "couldn't load / didn't load" note gets a friendly look and a Try again button
   - visitor guides and "Make a day of it" lists get a painted tile for each place's kind
   - the map shows a count on a pin standing for several places close together (tap it to zoom in), and a small key
   - the list says "Showing 36 of 617" with a link to the A to Z pages; a Trip guides tile; Back to top; a guide link
     when a search names a state, country, town or kind of stop (2026-10-18i)
   - the state list and each state or country guide show its painted state icon or flag (2026-10-18h)
   The painted icons come from the site's icon script, which swaps the emojis written here. */
(function () {
  if (window.__gfdPlus) return; window.__gfdPlus = 1;
  var TYPES = {
    'Lavender farm': '🪻', 'Apple orchard': '🍎', 'Cherry orchard': '🍒', 'Peach orchard': '🍑', 'Blueberry farm': '🫐', 'Strawberry farm': '🍓',
    'Berry farm': '🍇', 'Pumpkin patch': '🎃', 'Sunflower farm': '🌻', 'Christmas tree farm': '🎄', 'Winery': '🍷', 'Winery or vineyard': '🍷',
    'Brewery': '🍺', 'Brewery or taproom': '🍺', 'Distillery': '🥃', 'Cidery': '🍏', 'Flower farm': '💐', 'Vegetable farm': '🥕',
    'Vegetable farm or CSA': '🥕', 'Sugarhouse': '🍁', 'Maple sugarhouse': '🍁', 'Family fun farm': '🐄', 'Honey farm': '🐝', 'U-pick farm': '🧺',
    'Mixed U-pick farm': '🧺', 'Farm stand': '🥬', 'Gift shop': '🎁', 'Boutique': '👗', 'Café or coffee shop': '☕', 'Bakery': '🥐',
    'Restaurant': '🍽️', 'Farm market': '🧺', 'Florist': '💐', 'Garden center': '🪴', 'Apiary or honey house': '🐝', 'Spa or salon': '💆',
    'Inn or B&B': '🛏️', 'Farm stay or campground': '🏕️', 'Ice cream or creamery': '🍦', 'Tea room': '🫖', 'Event venue': '🎉',
    'Maker or artist': '🎨', 'Farm equipment dealer': '🚜', 'Grocery or co-op': '🛒'
  };
  var GUESS = [[/lavender/i, '🪻'], [/apple|orchard/i, '🍎'], [/cherr/i, '🍒'], [/peach/i, '🍑'], [/blueberr/i, '🫐'], [/strawberr/i, '🍓'], [/berr/i, '🍇'],
    [/pumpkin/i, '🎃'], [/sunflower/i, '🌻'], [/christmas|tree farm/i, '🎄'], [/win|vineyard/i, '🍷'], [/brew|taproom/i, '🍺'], [/distill/i, '🥃'],
    [/cider/i, '🍏'], [/flower|florist/i, '💐'], [/vegetable|csa/i, '🥕'], [/maple|sugar/i, '🍁'], [/honey|apiar|bee/i, '🐝'], [/caf|coffee|tea/i, '☕'],
    [/bak/i, '🥐'], [/restaurant|grill|bistro|kitchen/i, '🍽️'], [/inn|b&b|bed and breakfast|hotel|lodg/i, '🛏️'], [/camp|farm stay/i, '🏕️'],
    [/ice cream|creamery/i, '🍦'], [/garden/i, '🪴'], [/stand|market/i, '🧺'], [/shop|store|boutique|gift/i, '🎁'], [/venue|event/i, '🎉']];
  function kindOf(label) {
    label = String(label || '').split('·')[0].trim();
    if (TYPES[label]) return TYPES[label];
    for (var i = 0; i < GUESS.length; i++) if (GUESS[i][0].test(label)) return GUESS[i][1];
    return '🧺';
  }
  function groupOf(e) {
    if (/🪻|💐|🌻/.test(e)) return 'lav';
    if (/🍷|🍺|🥃|🍏/.test(e)) return 'sip';
    if (/☕|🥐|🍽|🍦|🫖|🛏|🏕|🎁|👗|🪴|💆|🎉|🎨|🛒|🚜/.test(e)) return 'shop';
    return 'harvest';
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;'}[c]; }); }

  // 1) painted covers for cards without a picture
  function covers(root) {
    var cards = root.querySelectorAll('.gfd-card.no-cov:not([data-gfdp])');
    for (var i = 0; i < cards.length; i++) {
      var c = cards[i], cb = c.querySelector('.gfd-cb'); if (!cb) continue;
      c.setAttribute('data-gfdp', '1');
      var t = c.querySelector('.gfd-type'), e = kindOf(t ? t.textContent : '');
      var d = document.createElement('div'); d.className = 'gfdp-cov gfdp-g-' + groupOf(e); d.setAttribute('aria-hidden', 'true');
      d.innerHTML = '<span class="gfdp-hill"></span><span class="gfdp-cic">' + e + '</span>';
      c.insertBefore(d, cb); c.classList.add('gfdp-on');
    }
  }
  // 1b) farms without their own photo yet: the 3D picture (or logo) and the painted cover take turns, like a photo carousel
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches, cars = [];
  function paintedSlide(cov, e) {
    if (cov.getAttribute('data-gfdp')) return; cov.setAttribute('data-gfdp', '1');
    var d = document.createElement('div'); d.className = 'gfdp-slide gfdp-cov gfdp-g-' + groupOf(e); d.setAttribute('aria-hidden', 'true');
    d.innerHTML = '<span class="gfdp-hill"></span><span class="gfdp-cic">' + e + '</span>';
    var dots = document.createElement('span'); dots.className = 'gfdp-dots';
    dots.innerHTML = '<button type="button" class="is-on" data-gfdp-go="0" aria-label="Picture 1 of 2"></button><button type="button" data-gfdp-go="1" aria-label="Picture 2 of 2"></button>';
    cov.appendChild(d); cov.appendChild(dots); cov.classList.add('gfdp-car');
    cars.push({el: cov, next: Date.now() + 4500 + Math.random() * 3000});
  }
  function show(cov, i) {
    cov.classList.toggle('gfdp-alt', i === 1);
    var b = cov.querySelectorAll('[data-gfdp-go]'); for (var k = 0; k < b.length; k++) b[k].classList.toggle('is-on', k === i);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-gfdp-go]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var cov = b.closest('.gfdp-car'); show(cov, +b.getAttribute('data-gfdp-go'));
    for (var k = 0; k < cars.length; k++) if (cars[k].el === cov) cars[k].next = Date.now() + 9000;
  }, true);
  setInterval(function () {
    if (reduce || document.hidden) return;
    var now = Date.now(), vh = window.innerHeight;
    cars = cars.filter(function (c) { return c.el.isConnected; });
    cars.forEach(function (c) {
      if (now < c.next) return; c.next = now + 5000 + Math.random() * 1500;
      var r = c.el.getBoundingClientRect(); if (r.bottom < 0 || r.top > vh || c.el.matches(':hover')) return;
      show(c.el, c.el.classList.contains('gfdp-alt') ? 0 : 1);
    });
  }, 1000);
  function carousels(root) {
    var c = root.querySelectorAll('.gfd-card .gfd-cov.is-game:not([data-gfdp]), .gfd-card .gfd-cov.is-logo:not([data-gfdp])');
    for (var i = 0; i < c.length; i++) { var t = c[i].closest('.gfd-card').querySelector('.gfd-type'); paintedSlide(c[i], kindOf(t ? t.textContent : '')); }
    var h = root.querySelectorAll('.gl-3dhero:not([data-gfdp])');
    for (var j = 0; j < h.length; j++) { var lt = document.querySelector('.gl-type'); paintedSlide(h[j], kindOf(lt ? lt.textContent : '')); }
    // a listing page with no cover yet: the painted cover behind its "add your own photo" note
    var n = root.querySelectorAll('.gfd-noreal:not([data-gfdp])');
    for (var k = 0; k < n.length; k++) {
      var lt2 = document.querySelector('.gl-type'), e = kindOf(lt2 ? lt2.textContent : '');
      n[k].setAttribute('data-gfdp', '1'); n[k].classList.add('gfdp-cov', 'gfdp-g-' + groupOf(e));
      var hl = document.createElement('span'); hl.className = 'gfdp-hill'; n[k].insertBefore(hl, n[k].firstChild);
    }
  }
  // 2) the painted star on the Sponsor and New listing badges
  function stars(root) {
    var els = root.querySelectorAll('.gbx span, .gfd-key span, .gfd-key b, .gfd-chip');
    for (var i = 0; i < els.length; i++) {
      var n = els[i].firstChild;
      if (n && n.nodeType === 3 && /^\s*★/.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace('★', '⭐');
    }
  }
  // 3) "Be the first to review" instead of five empty stars
  function firstReview(root) {
    var s = root.querySelectorAll('.gl-stars.is-none');
    for (var i = 0; i < s.length; i++) {
      var st = s[i], nx = st.nextElementSibling;
      if (!nx || !/^\s*No reviews yet\s*$/.test(nx.textContent)) continue;
      var a = document.createElement('a'); a.className = 'gfdp-firstrev';
      a.href = location.pathname + '?review=1'; a.textContent = '✍️ Be the first to review';
      st.parentNode.insertBefore(a, st); st.remove(); nx.remove();
    }
  }
  // 4) friendly "couldn't load" notes with a Try again button
  var ERR = /((?:Some listings|Reviews|The directory|Your [a-z]+)[^.]*(?:couldn[’']t|didn[’']t) load[^.]*\.(?:\s*Try again in a moment\.)?)/;
  function errors(root) {
    var els = root.querySelectorAll('.gfd-count, p.gl-muted, .gfd-err');
    for (var i = 0; i < els.length; i++) {
      var el = els[i], tx = el.textContent;
      if (el.getAttribute('data-gfdp-t') === tx || !ERR.test(tx)) continue;
      var m = tx.match(ERR), before = tx.slice(0, m.index).replace(/\s*·\s*$/, '');
      el.innerHTML = (before ? esc(before) : '') + '<span class="gfdp-err" role="status"><span class="gfdp-err-t">' + esc(m[1].replace(/\s*Try again in a moment\.\s*$/, '')) +
        '</span><button type="button" class="gfdp-retry" data-gfdp-retry>🔄 Try again</button></span>';
      el.classList.add('gfdp-has-err');
      el.setAttribute('data-gfdp-t', el.textContent);
    }
  }
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-gfdp-retry]')) location.reload(); });
  // 5) a painted tile for each place in visitor guides and "Make a day of it"
  function tiles(root) {
    var li = root.querySelectorAll('.gg-list li:not([data-gfdp]), .gfd-ssr__near li:not([data-gfdp])');
    for (var i = 0; i < li.length; i++) {
      var x = li[i], k = x.querySelector('.gg-k') || x.querySelector('span'); if (!x.querySelector('a') || !k) continue;
      x.setAttribute('data-gfdp', '1');
      var e = kindOf(k.textContent), s = document.createElement('span');
      s.className = 'gfdp-tile gfdp-g-' + groupOf(e); s.setAttribute('aria-hidden', 'true'); s.textContent = e;
      x.insertBefore(s, x.firstChild); x.classList.add('gfdp-on');
    }
  }
  // 6) the map: a count on a pin that stands for several places close together, and a key
  var mapState = {busy: false, last: 0, watched: null};
  function legend(map) {
    if (map.querySelector('.gfdp-key')) return;
    var k = document.createElement('div'); k.className = 'gfdp-key';
    k.innerHTML = '<span><i class="gfdp-kn">12</i> Several places: tap to zoom in</span><span><i class="gfdp-kd"></i> One place</span><span><i class="gfdp-kf"></i> Featured</span>';
    map.appendChild(k);
  }
  function cluster(map) {
    var pins = map.querySelectorAll('.gfd-mpin.maplibregl-marker'); if (!pins.length) return;
    legend(map);
    var box = map.getBoundingClientRect(), R = 42, cell = {}, reps = [];
    var list = Array.prototype.slice.call(pins).map(function (p) {
      var r = p.getBoundingClientRect();
      return {p: p, x: r.left + r.width / 2 - box.left, y: r.bottom - box.top - 14,
        w: (p.classList.contains('is-home') ? 3 : 0) + (p.querySelector('.gfd-mth') ? 2 : 0)};
    }).sort(function (a, b) { return b.w - a.w; });
    list.forEach(function (o) {
      var inView = o.x > -40 && o.y > -40 && o.x < box.width + 40 && o.y < box.height + 40;
      if (!inView) { o.p.classList.remove('gfdp-h'); o.n = 0; return; }
      var cx = Math.floor(o.x / R), cy = Math.floor(o.y / R), hit = null;
      for (var dx = -1; dx <= 1 && !hit; dx++) for (var dy = -1; dy <= 1 && !hit; dy++) {
        var b = cell[(cx + dx) + ':' + (cy + dy)]; if (!b) continue;
        for (var j = 0; j < b.length; j++) { var q = b[j]; if (Math.abs(q.x - o.x) < R && Math.abs(q.y - o.y) < R) { hit = q; break; } }
      }
      if (hit) { hit.n++; o.p.classList.add('gfdp-h'); return; }
      o.n = 1; o.p.classList.remove('gfdp-h'); (cell[cx + ':' + cy] = cell[cx + ':' + cy] || []).push(o); reps.push(o);
    });
    reps.forEach(function (o) {
      var b = o.p.querySelector('.gfdp-n');
      if (o.n > 1) { if (!b) { b = document.createElement('span'); b.className = 'gfdp-n'; o.p.appendChild(b); } b.textContent = o.n > 99 ? '99+' : String(o.n); o.p.setAttribute('data-gfdp-n', o.n); }
      else { if (b) b.remove(); o.p.removeAttribute('data-gfdp-n'); }
    });
  }
  function schedule(map) {
    if (mapState.busy) return; mapState.busy = true;
    var wait = Math.max(0, 90 - (Date.now() - mapState.last));
    setTimeout(function () { requestAnimationFrame(function () { mapState.busy = false; mapState.last = Date.now(); try { cluster(map); } catch (e) {} }); }, wait);
  }
  function watchMap(root) {
    var map = root.querySelector('.gfd-map.maplibregl-map'); if (!map) return;
    if (mapState.watched !== map) {
      mapState.watched = map;
      ['wheel', 'pointerup', 'touchend', 'mouseup', 'keyup'].forEach(function (ev) { map.addEventListener(ev, function () { schedule(map); setTimeout(function () { schedule(map); }, 400); }, {passive: true}); });
      map.addEventListener('pointermove', function (e) { if (e.buttons) schedule(map); }, {passive: true});
      // a numbered pin zooms in on its places (instead of opening just one of them)
      map.addEventListener('click', function (e) {
        var pin = e.target.closest && e.target.closest('.gfd-mpin[data-gfdp-n]'); if (!pin) return;
        e.preventDefault(); e.stopPropagation();
        var r = pin.getBoundingClientRect(), cv = map.querySelector('.maplibregl-canvas') || map;
        var o = {bubbles: true, cancelable: true, clientX: r.left + r.width / 2, clientY: r.bottom - 14, view: window};
        cv.dispatchEvent(new MouseEvent('dblclick', o));
        setTimeout(function () { schedule(map); }, 350); setTimeout(function () { schedule(map); }, 800);
      }, true);
      // pins move on every animation frame while the map pans or zooms: re-count when they settle
      var mo = new MutationObserver(function () { schedule(map); });
      mo.observe(map, {attributes: true, subtree: true, attributeFilter: ['style'], childList: true});
    }
    schedule(map);
  }

  // 7) painted state icons and flags on the state list and on state and country guides (a painted lavender or globe until a painting exists)
  var ST = {Alabama:'al',Alaska:'ak',Arizona:'az',Arkansas:'ar',California:'ca',Colorado:'co',Connecticut:'ct',Delaware:'de',Florida:'fl',Georgia:'ga',Hawaii:'hi',Idaho:'id',Illinois:'il',Indiana:'in',Iowa:'ia',Kansas:'ks',Kentucky:'ky',Louisiana:'la',Maine:'me',Maryland:'md',Massachusetts:'ma',Michigan:'mi',Minnesota:'mn',Mississippi:'ms',Missouri:'mo',Montana:'mt',Nebraska:'ne',Nevada:'nv','New Hampshire':'nh','New Jersey':'nj','New Mexico':'nm','New York':'ny','North Carolina':'nc','North Dakota':'nd',Ohio:'oh',Oklahoma:'ok',Oregon:'or',Pennsylvania:'pa','Rhode Island':'ri','South Carolina':'sc','South Dakota':'sd',Tennessee:'tn',Texas:'tx',Utah:'ut',Vermont:'vt',Virginia:'va',Washington:'wa','West Virginia':'wv',Wisconsin:'wi',Wyoming:'wy'};
  function icoBase() { var s = document.querySelector('script[src*="gllf-icons.js"][data-base]'); return s ? s.getAttribute('data-base') : '/cdn/shop/t/2/assets/gllf-ico-'; }
  function paintedImg(name, fb, cls) {
    var b = icoBase(), i = document.createElement('img'); i.className = cls; i.alt = ''; i.loading = 'lazy'; i.decoding = 'async'; i.width = 48; i.height = 48;
    i.onerror = function () { i.onerror = null; i.src = b + fb + '.webp'; i.classList.add('is-fb'); }; i.src = b + name + '.webp'; return i;
  }
  function places(root) {
    var a = root.querySelectorAll('.gg-states a:not([data-gfdp])');
    for (var k = 0; k < a.length; k++) {
      var nm = a[k].querySelector('b'), code = nm && ST[nm.textContent.trim()]; a[k].setAttribute('data-gfdp', '1'); if (!code) continue;
      a[k].insertBefore(paintedImg('state-' + code, 'lavender-sprig', 'gfdp-sic'), a[k].firstChild); a[k].classList.add('gfdp-on');
    }
    var g = document.getElementById('gllf-guide'), hero = document.querySelector('.gg-hero');
    if (g && hero && !hero.querySelector('.gfdp-hic')) {
      var sc = (g.getAttribute('data-scope') || '').split(':'), h = g.getAttribute('data-h') || '', img = null;
      if (sc[0] === 'state' && sc[1]) img = paintedImg('state-' + sc[1].toLowerCase(), 'lavender-sprig', 'gfdp-hic');
      else if (sc[0] === 'country') { var fl = h.replace(/^lavender-farms-in-/, ''); if (fl === 'turkiye') fl = 'turkey'; img = paintedImg('flag-' + fl, 'globe', 'gfdp-hic'); }
      if (img) { img.width = img.height = 160; hero.classList.add('gfdp-has-hic'); hero.appendChild(img); }
    }
  }

  // 8) the list: "Showing 36 of 617" by Show more, a link to the A-to-Z pages, a fifth "Trip guides" tile, Back to top,
  //    and a line linking the matching guide when a search names a state, country, town or kind of stop (2026-10-18i)
  function listBits() {
    var more = document.querySelector('#gllf-dir [data-more]'), mp = more && more.parentNode;
    if (mp && !mp.querySelector('.gfdp-shown')) {
      var sh = document.createElement('span'); sh.className = 'gfdp-shown'; sh.setAttribute('aria-live', 'polite'); mp.appendChild(sh);
      if (document.getElementById('gfd-az')) { var az = document.createElement('a'); az.className = 'gfdp-azl'; az.href = '#gfd-az'; az.textContent = 'Browse every listing A to Z'; mp.appendChild(az); }
    }
    if (mp) {
      var n = document.querySelectorAll('#gllf-dir [data-grid] > .gfd-card').length, c = document.querySelector('#gllf-dir [data-count]'),
        m = c && c.textContent.replace(/,/g, '').match(/(\d+)\s+listings?/), total = m ? +m[1] : 0, sh2 = mp.querySelector('.gfdp-shown');
      if (sh2) { var t = !total || !n ? '' : n >= total ? 'All ' + total.toLocaleString('en-US') + ' shown' : 'Showing ' + n.toLocaleString('en-US') + ' of ' + total.toLocaleString('en-US'); if (sh2.textContent !== t) sh2.textContent = t; }
    }
    var ties = document.querySelector('#gllf-dir .gfd-ties > div');
    if (ties && !ties.querySelector('[data-gfdp-tg]') && document.getElementById('gnv-h')) {
      var a = document.createElement('a'); a.href = '#gnv-h'; a.setAttribute('data-gfdp-tg', '1');
      var k = document.querySelectorAll('nav.gnv a[href*="/pages/farm-trips/"]').length;
      a.innerHTML = '<b>🗺️ Trip guides</b>' + (k ? 'Every state, country and kind of stop' : 'Guides by state and kind of stop');
      ties.appendChild(a); ties.classList.add('gfdp-five');
    }
  }
  var guideIx = null;
  function guides() {
    if (guideIx) return guideIx; guideIx = [];
    var seen = {};
    document.querySelectorAll('nav.gnv a[href*="/pages/farm-trips/"]').forEach(function (a) {
      var h = a.getAttribute('href'); if (seen[h]) return; seen[h] = 1;
      var li = a.closest('[data-n]'), key = (li ? li.getAttribute('data-n') : a.textContent).toLowerCase(), b = a.querySelector('b');
      guideIx.push({h: h, key: key, t: (b ? b.textContent : a.textContent).replace(/\s+/g, ' ').trim(), area: !!a.closest('.gnv-reg')});
    });
    return guideIx;
  }
  function hint() {
    var tn = document.querySelector('#gllf-dir [data-tabnote]'); if (!tn) return;
    var q = document.querySelector('#gllf-dir [data-q]'), v = q ? q.value.trim().toLowerCase() : '', box = tn.parentNode.querySelector('.gfdp-ghint');
    var hit = null;
    if (v.length >= 3) {
      var list = guides();
      for (var i = 0; i < list.length && !hit; i++) if (!list[i].area && list[i].key.split(/\s+/).concat([list[i].key]).some(function (w) { return w === v || w.indexOf(v) === 0 && v.length >= 4; })) hit = list[i];
      for (var j = 0; j < list.length && !hit; j++) if (list[j].key.indexOf(v) > -1 && v.length >= 4) hit = list[j];
    }
    if (!hit) { if (box) box.remove(); return; }
    if (!box) { box = document.createElement('p'); box.className = 'gfdp-ghint'; tn.parentNode.insertBefore(box, tn.nextSibling); }
    var html = '📖 There’s a trip guide for this: <a href="' + esc(hit.h) + '">' + esc(hit.t) + ' →</a>';
    if (box.innerHTML !== html) box.innerHTML = html;
  }
  document.addEventListener('input', function (e) { if (e.target.matches && e.target.matches('#gllf-dir [data-q]')) setTimeout(hint, 200); });
  var top = null;
  function backTop() {
    if (!document.querySelector('#gllf-dir [data-grid]') || document.querySelector('.gfd-sheet.is-page')) return;
    if (!top) {
      top = document.createElement('button'); top.type = 'button'; top.className = 'gfdp-top'; top.hidden = true; top.textContent = '↑ Top'; top.setAttribute('aria-label', 'Back to the top of Farm Day Trips');
      top.addEventListener('click', function () { var d = document.getElementById('gllf-dir'); window.scrollTo({top: d ? d.getBoundingClientRect().top + scrollY - 80 : 0, behavior: reduce ? 'auto' : 'smooth'}); });
      document.body.appendChild(top);
      var tick = 0; window.addEventListener('scroll', function () { if (tick) return; tick = 1; requestAnimationFrame(function () { tick = 0; top.hidden = window.scrollY < 2200; }); }, {passive: true});
    }
  }

  function run(root) {
    root = root || document;
    try { covers(root); } catch (e) {}
    try { carousels(root); } catch (e) {}
    try { stars(root); } catch (e) {}
    try { firstReview(root); } catch (e) {}
    try { errors(root); } catch (e) {}
    try { tiles(root); } catch (e) {}
    try { watchMap(root); } catch (e) {}
    try { places(root); } catch (e) {}
    try { listBits(); backTop(); } catch (e) {}
  }
  var queued = false;
  function later() { if (queued) return; queued = true; setTimeout(function () { queued = false; run(document); }, 120); }
  function start() {
    run(document);
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var t = list[i].target;
        if (t && t.closest && t.closest('.maplibregl-marker')) continue;
        if (list[i].addedNodes.length || list[i].type === 'characterData') { later(); return; }
      }
    }).observe(document.body, {childList: true, subtree: true, characterData: true});
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start) : start();
})();
;/* 2026-10-28 · the Farm Feed on the Farm Day Trips page */(function(){try{if(window.__gllfDFeedL)return;window.__gllfDFeedL=1;var c=document.currentScript,u=c&&c.src?c.src.replace(/gllf-fdt-plus\.js.*$/,'gllf-fdt-feed.js?v=20261122a'):'';if(!u||u===c.src)return;var x=document.createElement('script');x.src=u;x.defer=true;document.head.appendChild(x)}catch(e){}})();
;/* 2026-10-28 · the Farm Day Trips page, app-style */(function(){try{if(window.__gllfShellL)return;window.__gllfShellL=1;var c=document.currentScript,u=c&&c.src?c.src.replace(/gllf-fdt-plus\.js.*$/,'gllf-fdt-shell.js?v=20261028e'):'';if(!u||u===c.src)return;var x=document.createElement('script');x.src=u;x.defer=true;document.head.appendChild(x)}catch(e){}})();
;(function(){try{if(window.__gllfAdsL)return;window.__gllfAdsL=1;var c=document.currentScript,u=c&&c.src?c.src.replace(/gllf-fdt-plus\.js.*$/,"gllf-fdt-adslots.js?v=20261029a"):"";if(!u||u===c.src)return;var x=document.createElement("script");x.src=u;x.defer=true;document.head.appendChild(x)}catch(e){}})(); /* v2026-10-29: Farm Day Trips ad spots */
;(function(){try{if(window.__gllfStudioL)return;window.__gllfStudioL=1;var c=document.currentScript,u=c&&c.src?c.src.replace(/gllf-fdt-plus\.js.*$/,"gllf-fdt-studio.js?v=20261125a"):"";if(!u||u===c.src)return;var x=document.createElement("script");x.src=u;x.defer=true;document.head.appendChild(x)}catch(e){}})(); /* v2026-10-29: Listing Studio and marketing kit */
;(function(){try{if(window.__gllfLiveL)return;window.__gllfLiveL=1;var c=document.currentScript,b=c&&c.src?c.src.replace(/gllf-fdt-plus\.js.*$/,""):"";if(!b||b===c.src)return;var x=document.createElement("script");x.src=b+"gllf-fdt-live.js?v=20261030a";x.defer=true;document.head.appendChild(x);var x=document.createElement("script");x.src=b+"gllf-fdt-tix.js?v=20261031a";x.defer=true;document.head.appendChild(x);}catch(e){}})(); /* v2026-10-29: live status, harvest alerts and tickets */
;(function(){try{if(window.__gllfGrowL)return;window.__gllfGrowL=1;var c=document.currentScript,b=c&&c.src?c.src.replace(/gllf-fdt-plus\.js.*$/,""):"";if(!b||b===c.src)return;var x=document.createElement("script");x.src=b+"gllf-fdt-grow.js?v=20261030a";x.defer=true;document.head.appendChild(x);}catch(e){}})(); /* v2026-10-30: Plan my day, coach, loyalty and wholesale */
;(function(){try{if(window.__gllfBizL)return;window.__gllfBizL=1;var c=document.currentScript,b=c&&c.src?c.src.replace(/gllf-fdt-plus\.js.*$/,""):"";if(!b||b===c.src)return;var x=document.createElement("script");x.src=b+"gllf-fdt-biz.js?v=20261102a";x.defer=true;document.head.appendChild(x);}catch(e){}})(); /* v2026-10-30: business tools */
;(function(){try{if(window.__gllfStL722)return;window.__gllfStL722=1;var c=document.currentScript,b=c&&c.src?c.src.replace(/gllf-fdt-plus\.js.*$/,""):"";if(!b||b===c.src)return;var x=document.createElement("script");x.src=b+"gllf-fdt-stamps.js?v=20261105a";x.defer=true;document.head.appendChild(x);}catch(e){}})(); /* v2026-11-02: stamps everywhere */
